import xBtn from "../icons/cross.png";
import { IModalProps } from "../interfaces/Interfaces";
import dots from "../icons/dots.svg";

const Modal = ({
  drink,
  setModal,
  modal,
  recipe,
  loadingRecipe,
  setLoadingRecipe,
}: IModalProps) => {
  return (
    <div className="fixed z-50 w-full h-screen flex justify-center items-start backdrop-blur-sm">
      {loadingRecipe === false ? (
        <div className="relative w-full h-4/5 lg:w-80 xl:w-80 2xl:w-80 bg-black text-white flex flex-col justify-start items-center p-10 text-center overflow-auto scroll-smooth rounded-md animate-fadeIn">
          <img
            className="absolute z-50 top-0 right-0 p-2 w-8 hover:scale-125"
            src={xBtn}
            alt="Close modal pop-up"
            onClick={() => {
              setModal(!modal);
              setLoadingRecipe(true);
            }}
          />
          <h1 className="text-xl font-bold p-5">{drink.strDrink}</h1>

          <img src={`${drink.strDrinkThumb}/preview`} alt={drink.strDrink} />

          <div className="p-3">
            <h3 className="text-lg font-bold">Ingredients:</h3>
            <ol className="list-disc">
              {recipe.map((el) => (
                <li key={el}>{el}</li>
              ))}
            </ol>
          </div>

          <div className="p-3">
            <h3 className="text-lg font-bold">Instructions:</h3>
            <p>{drink.strInstructions}</p>
          </div>
        </div>
      ) : (
        <div className="relative w-full h-4/5 lg:w-80 xl:w-80 2xl:w-80 bg-black text-white flex justify-center items-center rounded-md animate-fadeIn">
          <img src={dots} alt="loading animation" />
        </div>
      )}
    </div>
  );
};

export { Modal };
